module.exports = __webpack_public_path__ + "img/feuerwehrlunestedt.f0b66d70.jpg";